import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import { decorateElement } from 'fg-frontend/src/webComponents/decorate';

tinymce.baseURL = '/tinymce';

class ForumAnswerActions extends WebComponent {

  constructor(props) {
    super(props);
  }

  didMount() {
    this.on('click', this.handleClick);
  }

  handleClick = (event) => {
    const {
      buttonActiveClass,
    } = this.props;

    event.preventDefault();

    if (!this.element.classList.contains(buttonActiveClass)) {
      const activeButtons = document.querySelectorAll(`.${  buttonActiveClass }`);
      if (activeButtons.length > 0) {
        activeButtons.forEach((hiddenButton) => {
          hiddenButton.classList.remove(buttonActiveClass);
          hiddenButton.parentElement.nextElementSibling.remove();
        });
      }
      this.element.classList.add(buttonActiveClass);
      $.get(this.element.getAttribute('href'), (data) => {
        this.element.parentElement.insertAdjacentHTML('afterend', `<div class="forum__loaded-content">${ data }</div>`);
        const textArea = this.element.parentElement.parentElement.querySelectorAll('#body')[0];
        const random = Math.floor(Math.random() * 1000000) + 1;
        textArea.setAttribute('id','body-'+random);
        decorateElement(textArea);
      });
    } else {
      this.element.classList.remove(buttonActiveClass);
      this.element.parentElement.nextElementSibling.remove();
    }
  }

}

ForumAnswerActions.defaultProps = {
  buttonActiveClass: 'forum__btn-reaction--active',
};

export default ForumAnswerActions;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ForumAnswerActions.js